/*
 * Actividad del día de una cartera de clientes ("Mis Clientes" del comercial y del
 * productor): cuántas órdenes, cauciones/pases e instrucciones hay y en qué estado.
 * Las colecciones operativas son del día (el cierre diario las vacía), salvo las
 * instrucciones programadas, que se cuentan aparte.
 */

export const GRUPOS_ACTIVIDAD = ['operaciones', 'financiacion', 'instrucciones'];

export const ESTADOS_ACTIVIDAD = ['Programada', 'Pendiente', 'En Proceso', 'Hecha', 'Rechazada'];

// Hay cauciones viejas con 'Hecha ' o 'En proceso'.
const normalizarEstado = (estado) => {
  const limpio = String(estado || '').trim().toLowerCase();
  return ESTADOS_ACTIVIDAD.find(e => e.toLowerCase() === limpio) || null;
};

const grupoVacio = () => ({
  total: 0,
  porEstado: ESTADOS_ACTIVIDAD.reduce((acc, estado) => ({ ...acc, [estado]: 0 }), {}),
});

const sumar = (grupo, estado) => {
  grupo.total += 1;
  grupo.porEstado[estado] += 1;
};

/** Órdenes que todavía esperan a la mesa o a Middle Office. */
export const pendientesDe = (grupo) =>
  grupo.porEstado.Pendiente + grupo.porEstado['En Proceso'] + grupo.porEstado.Rechazada;

/**
 * @param {{ operaciones?: object[], cauciones?: object[], pases?: object[], instrucciones?: object[] }} docs
 * @returns {{ totales: Record<string, object>, porComitente: Map<string, Record<string, object>> }}
 *   Cada grupo es { total, porEstado }. Lo eliminado o con estado desconocido no cuenta.
 */
export const resumirActividad = ({ operaciones = [], cauciones = [], pases = [], instrucciones = [] }) => {
  const totales = GRUPOS_ACTIVIDAD.reduce((acc, g) => ({ ...acc, [g]: grupoVacio() }), {});
  const porComitente = new Map();

  const registrar = (grupoKey, doc) => {
    const estado = normalizarEstado(doc?.estado);
    if (!estado) return;
    const nroComitente = String(doc.nroComitente || '');
    if (!porComitente.has(nroComitente)) {
      porComitente.set(nroComitente, GRUPOS_ACTIVIDAD.reduce((acc, g) => ({ ...acc, [g]: grupoVacio() }), {}));
    }
    sumar(totales[grupoKey], estado);
    sumar(porComitente.get(nroComitente)[grupoKey], estado);
  };

  operaciones.forEach(doc => registrar('operaciones', doc));
  cauciones.forEach(doc => registrar('financiacion', doc));
  pases.forEach(doc => registrar('financiacion', doc));
  instrucciones.forEach(doc => registrar('instrucciones', doc));

  return { totales, porComitente };
};
